import React from "react";
import DOMPurify from "dompurify";

/**
 * Props:
 *  - html (string): HTML string to render
 *  - className (string): optional wrapper class
 */
const SafeHtmlRenderer = ({ html, className = "" }) => {
  const cleanHTML = React.useMemo(() => {
    return DOMPurify.sanitize(html, {
      USE_PROFILES: { html: true }, // allow basic HTML safely
    });
  }, [html]);

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: cleanHTML }}
    />
  );
};

export default SafeHtmlRenderer;
